import { createRouter, createWebHistory } from 'vue-router'

// 路由懒加载，减少首屏 chunk 体积
const HomePage = () => import('@/pages/HomePage.vue')
const UserQueryPage = () => import('@/pages/UserQueryPage.vue')
const VideoAnalysisPage = () => import('@/pages/VideoAnalysisPage.vue')
const ToolboxPage = () => import('@/pages/ToolboxPage.vue')
const TotpVerifyPage = () => import('@/pages/TotpVerifyPage.vue')
const QrcodeScanPage = () => import('@/pages/QrcodeScanPage.vue')
const IpDetectionPage = () => import('@/pages/IpDetectionPage.vue')
const ProxyCheckPage = () => import('@/pages/ProxyCheckPage.vue')
const ProxyTkRegionPage = () => import('@/pages/ProxyTkRegionPage.vue')
const MailToolPage = () => import('@/pages/MailToolPage.vue')
const PartnersPage = () => import('@/pages/PartnersPage.vue')
const PartnerDetailPage = () => import('@/pages/PartnerDetailPage.vue')
const DashboardPage = () => import('@/pages/DashboardPage.vue')
const AboutPage = () => import('@/pages/AboutPage.vue')
const AnnouncementsPage = () => import('@/pages/AnnouncementsPage.vue')
const AdminLoginPage = () => import('@/pages/AdminLoginPage.vue')
const AdminDashboardPage = () => import('@/pages/AdminDashboardPage.vue')

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomePage,
    meta: {
      title: '首页',
      icon: 'fas fa-home'
    }
  },
  {
    path: '/user-query',
    name: 'user-query',
    component: UserQueryPage,
    meta: {
      title: '用户查询',
      icon: 'fas fa-user-circle'
    }
  },
  {
    path: '/video-analysis',
    name: 'video-analysis',
    component: VideoAnalysisPage,
    meta: {
      title: '用户视频',
      icon: 'fas fa-video'
    }
  },
  {
    path: '/toolbox',
    name: 'toolbox',
    component: ToolboxPage,
    meta: {
      title: '链接工具箱',
      icon: 'fas fa-toolbox'
    }
  },
  {
    path: '/totp-verify',
    name: 'totp-verify',
    component: TotpVerifyPage,
    meta: {
      title: '2FA验证',
      icon: 'fas fa-key'
    }
  },
  {
    path: '/qrcode-scan',
    name: 'qrcode-scan',
    component: QrcodeScanPage,
    meta: {
      title: '二维码扫描',
      icon: 'fas fa-qrcode'
    }
  },
  {
    path: '/ip-detection',
    name: 'ip-detection',
    component: IpDetectionPage,
    meta: {
      title: 'IP检测',
      icon: 'fas fa-globe'
    }
  },
  {
    path: '/proxy-check',
    name: 'proxy-check',
    component: ProxyCheckPage,
    meta: {
      title: '代理检查',
      icon: 'fas fa-shield-alt'
    }
  },
  {
    path: '/proxy-tk-region',
    name: 'proxy-tk-region',
    component: ProxyTkRegionPage,
    meta: {
      title: '代理地区检测',
      icon: 'fas fa-map-marker-alt'
    }
  },
  {
    path: '/mail-tool',
    name: 'mail-tool',
    component: MailToolPage,
    meta: {
      title: '邮件收取',
      icon: 'fas fa-envelope'
    }
  },
  {
    path: '/partners',
    name: 'partners',
    component: PartnersPage,
    meta: {
      title: '合作伙伴',
      icon: 'fas fa-handshake',
      fullWidth: true
    }
  },
  {
    path: '/partners/:id',
    name: 'partner-detail',
    component: PartnerDetailPage,
    meta: {
      title: '合作伙伴详情',
      icon: 'fas fa-info-circle',
      fullWidth: true
    }
  },
  {
    path: '/admin/login',
    name: 'admin-login',
    component: AdminLoginPage,
    meta: {
      title: '管理员登录',
      icon: 'fas fa-sign-in-alt'
    }
  },
  {
    path: '/admin',
    redirect: '/admin/dashboard'
  },
  {
    path: '/admin/dashboard',
    name: 'admin-dashboard',
    component: AdminDashboardPage,
    meta: {
      title: '后台管理',
      icon: 'fas fa-cog',
      requiresAdmin: true  // 标记为管理员页面
    }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: DashboardPage,
    meta: {
      title: '数据仪表板',
      icon: 'fas fa-chart-dashboard',
      fullWidth: true
    }
  },
  {
    path: '/about',
    name: 'about',
    component: AboutPage,
    meta: {
      title: '关于我们',
      icon: 'fas fa-info-circle',
      fullWidth: true
    }
  },
  {
    path: '/announcements',
    name: 'announcements',
    component: AnnouncementsPage,
    meta: {
      title: '更新公告',
      icon: 'fas fa-bullhorn',
      fullWidth: true
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（例如浏览器后退），则返回到保存的位置
    if (savedPosition) {
      return savedPosition
    }

    // hash 跳转：考虑顶部 Header 高度（含安全区），避免被遮挡
    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          const el = document.querySelector(to.hash)
          if (!el) {
            resolve({ top: 0 })
            return
          }

          const header = document.querySelector('.app-header')
          const headerHeight = header ? header.getBoundingClientRect().height : 0
          resolve({
            el: to.hash,
            top: headerHeight + 12,
            behavior: 'smooth'
          })
        }, 0)
      })
    }

    // 否则滚动到页面顶部
    return { top: 0, behavior: 'smooth' }
  }
})

export default router
